<template>
  <div class="page-container-movie">
    <Goback :path="toPath"></Goback>
    <DonatePopup v-model="showDonatePopup" :refer="itemId" v-if="itemId"></DonatePopup>
    <ItemActionStatsEmit :delay="3000" action="view" :itemId="itemId" itemType="movie" :key="itemId"
                         v-if="itemId && !showLoading"></ItemActionStatsEmit>

    <transition name="slide">
      <div class="item-full-container">
        <div>
          <div class="video-player-container" v-if="showVideoBox">
            <div id="xg"></div>
          </div>
          <div class="video-container" @click="onClickPlayVideo" v-else>
            <div class="video-cover-mask" v-if="!showLoading">
              <img class="img-video-cover" :src="coverUrl(item)"/>
              <div class="duration"> {{getDuration(item)}}</div>
              <div class="unlock-desc" v-if="showNeedAuth || !this.isLogin" @click="onClickExchange">
                <img class="play-icon-unlock" src="https://a1.wanwanshequ.com/static/public/89c3705ffd940f1a.png"/>
                <div class="unlock-text">{{creditChangeButtonText}}</div>
              </div>
              <div v-else>
                <img class="play-icon" src="https://a1.wanwanshequ.com/static/public/play.png"/>
              </div>
            </div>
          </div>
        </div>

        <div class="info-container" @click="onShowDetail">
          <div class="item-title-container">
            {{item.title}}
          </div>
          <div class="action-container">
            <div class="txt">简介</div>
            <Icon name="arrow"/>
          </div>
        </div>

        <div class="action-bar-container">
          <div class="actions">
            <div class="action-item">
              <Favorite :item="actionItem" v-if="actionItemId"></Favorite>
            </div>
          </div>
          <div class="change-line-btn-container">
            <div class="btn-container" v-if="showHome">
              <Button size="small" round plain @click="onToHome">
                <div class="back-home">
                  <Icon name="home-o"></Icon>
                  <div class="txt">返回首页</div>
                </div>
              </Button>
            </div>
            <div class="btn-container">
              <Button @click="onClickChangeLineButton" size="small" type="warning" plain round>
                <div class="back-home">
                  <Icon name="exchange"></Icon>
                  <div class="txt">切换线路</div>
                </div>
              </Button>
            </div>
            <ChangeLineActions ref="changeLineAction" @changeLine="onChangeLine"></ChangeLineActions>
          </div>
        </div>

        <div class="series-container">
          <cube-scroll :data="series" v-if="series && series.length > 0" direction="horizontal"
                       class="horizontal-scroll-list-wrap">
            <ul class="item-list-wrapper">
              <li class="cell-item" v-for="(item, idx) in series" @click="onChangeSeries(item)">
                <div :class="['series-box', item === itemId?'selected-series':'']">{{ idx + 1 }}
                </div>
              </li>
            </ul>
          </cube-scroll>
        </div>

        <CommentInfo :itemId="actionItemId" v-if="actionItemId"></CommentInfo>

        <Popup v-model="showDetailPopup" position="bottom" class="detail-info-popup" v-if="!showLoading">
          <div class="item-display-text-container">
            <div class="movie-info-container">
              <div class="movie-cover">
                <img :src="coverPage" class="movie-cover-img"/>
              </div>
              <ul class="movie-info">
                <li>
                  地区：<span>{{releaseRegion}}</span>
                </li>
                <li>
                  上映日期：<span>{{releaseData}}</span>
                </li>
                <li>
                  导演：<span>{{directors}}</span>
                </li>
                <li>
                  主演：<span>{{actors}}</span>
                </li>
                <li>
                  标签：<span>{{tags}}</span>
                </li>
                <li>
                  豆瓣评分：<span>{{score}}</span>
                </li>
              </ul>
            </div>
            <div class="brief-movie">
              {{movieDesc}}
            </div>
          </div>
        </Popup>
      </div>

    </transition>
  </div>
</template>

<script>
  import {Dialog, Popup, Icon, Switch, Button, Notify, Toast, Collapse, CollapseItem} from "vant"

  import Player from 'xgplayer';
  import ChangeLineActions from "../../common/ChangeLineActions";
  import Goback from "../../common/Goback";
  import DonatePopup from "../../common/DonatePopup";
  import {IsApp} from "../../../util/common";
  import CommentInfo from "../../comment/CommentInfo";
  import Favorite from "../../common/Favorite";
  import ItemActionStatsEmit from "../../common/ItemActionStatsEmit";

  export default {
    name: "MovieDetail",
    components: {
      ItemActionStatsEmit,
      Favorite,
      CommentInfo,
      DonatePopup,
      Goback,
      ChangeLineActions,
      Popup,
      Button,
      Icon,
      [Switch.name]: Switch,
      Dialog,
      Notify,
      Toast,
      Collapse,
      CollapseItem
    },

    data() {
      return {
        player: null,
        showLoading: true,
        isLogin: true,

        item: {},
        actionItem: {},

        itemId: 0,
        actionItemId: 0,

        showLoginPopup: false,
        showDonatePopup: false,
        seriesList: [],

        relatedItems: [],
        activeNames: ["pics", "articles"],

        showDetailPopup: false,
        showHome: false,
        toPath: "",
      };
    },
    async mounted() {
      this.itemId = parseInt(this.$route.params.id)
      this.actionItemId = this.itemId
      let source = this.$route.query.utm_source
      if (source) {
        this.toPath = "/_tab_discovery"
        this.showHome = true
      }

      this.init()
      this.getCachedUserInfo()
    },
    methods: {

      onToHome() {
        this.$router.push(this.toPath)
      },

      onClickPlayVideo() {
        if (this.useNativePlayer && !this.showNeedAuth) {
          if (this.item.video_url) {
            window.injectedObject.startVideoPlayer(this.item.video_url)
          }
        }
      },

      getCachedUserInfo() {
        this.$store.dispatch("CacheAccountInfoMine").then((data) => {
          if (data && data.id) {
            this.isLogin = true
          } else {
            this.isLogin = false
          }
        }, () => {
        })
      },

      destroyPlayer() {
        if (this.player) {
          try {
            this.player.destroy();
          } catch (e) {
            console.log(e)
          }
        }
      },

      initVideoInfo() {
        this.destroyPlayer()
        let checkExist = setInterval(() => {
          let xg = document.getElementById("xg")
          if (xg) {
            this.player = null;
            this.player = new Player({
              id: 'xg',
              poster: this.coverUrl(this.item),
              url: this.item.video_url,
              fluid: true,
              fitVideoSize: 'auto',
              lang: 'zh-cn',
              controlsList: ['nodownload']
            });
            clearInterval(checkExist);
          }
        }, 100);
      },
      async init() {
        this.showLoading = true
        this.item = {}
        let q = this.$route.query
        let queries = {}
        for (let i in q) {
          queries[i] = q[i]
        }
        queries.id = this.itemId
        await this.$store.dispatch("GetUgcItem", queries).then((data) => {
              if (data.code !== 0) {
                Toast.fail("内容不存在")
              } else {
                this.item = data.data;
                if (!this.actionItem || !this.actionItem.id) {
                  if (this.actionItemId === this.item.id) {
                    this.actionItem = this.item
                  }
                }
                if (this.showVideoBox) {
                  this.initVideoInfo()
                }
              }
            }, () => {
              Toast.fail("网络错误")
            }
        );
        this.showLoading = false
      },

      getDuration(item) {
        let t = item.duration
        if (Math.floor(t / 3600) > 0) {
          return ('0' + Math.floor(t / 3600) % 24).slice(-2) + ':' + ('0' + Math.floor(t / 60) % 60).slice(-2) + ':' + ('0' + t % 60).slice(-2)
        } else {
          return ('0' + Math.floor(t / 60) % 60).slice(-2) + ':' + ('0' + t % 60).slice(-2)
        }
      },

      onShowDetail() {
        this.showDetailPopup = true
      },
      getTitle(item) {
        if (!item || !item.title) {
          return ""
        }
        return item.title
      },

      getNickName(item) {
        if (!item || !item.user) {
          return ""
        }
        return item.user.nickname
      },

      onClickChangeLineButton() {
        this.$refs.changeLineAction.showChangeLine()
      },

      onClickExchange() {
        if (!this.isLogin) {
          this.$router.push("/login")
          return
        }

        this.$createDialog({
          type: 'confirm',
          content: `确认解锁`,
          confirmBtn: {
            text: '确定',
            active: true,
            href: 'javascript:;'
          },
          cancelBtn: {
            text: '取消',
            active: false,
            disabled: false,
            href: 'javascript:;'
          },
          onConfirm: () => {
            this.doExchange()
          },
          onCancel: () => {
          }
        }).show()

      },

      doExchange() {
        let params = {
          item_id: '' + this.itemId,
          item_type: "look",
        };
        this.$store.dispatch("ExchangeCredit", params).then((data) => {
          if (data.code === 0) {
            this.$createToast({
              txt: `解锁成功`,
              type: "text",
              time: 1000,
            }).show()
            this.init()
          } else if (data.code === 20010) {
            this.$router.push("/login")
          } else if (data.code === 30001) {
            this.showDonatePopup = true
          } else {
            this.$createToast({
              txt: `系统错误`,
              type: "error",
              time: 1000,
            }).show()
          }
        }, (error) => {
          console.log(error)
        })
      },

      onChangeLine() {
        this.init()
      },

      onChangeSeries(itemId) {
        this.itemId = itemId
        this.init()
        this.destroyPlayer()
      },

      coverUrl(item) {
        if (item && item.preview_urls) {
          return item.preview_urls[0]
        } else {
          return ""
        }
      },
    },
    watch: {
      relatedItems(newVal, oldVal) {
        if (newVal && newVal.length > 0) {
          this.activeNames = ["articles"]
        }
      }
    },
    computed: {
      showVideoBox() {
        if (!this.showNeedAuth && this.isLogin && !this.useNativePlayer) {
          return true
        } else {
          return false
        }
      },

      useNativePlayer() {
        if (this.showNeedAuth) {
          return false
        }

        if (IsApp && window.injectedObject && window.injectedObject.startVideoPlayer) {
          return true
        } else {
          return false
        }
      },

      showNeedAuth() {
        if (this.item) {
          if (this.item.with_auth === false && this.item.is_auth === false) {
            return true
          }
        }
        return false
      },

      series() {
        if (this.seriesList && this.seriesList.length > 0) {
          return this.seriesList
        }
        if (this.item && this.item.series) {
          this.seriesList = this.item.series
        }
        return this.seriesList
      },

      creditChangeButtonText() {
        if (!this.isLogin) {
          return "登录/注册"
        }

        if (this.item && this.item.credit) {
          return "" + this.item.credit + "币解锁观看"
        }
        return ""
      },

      movieDesc() {
        return this.item.description
      },

      releaseRegion() {
        return this.item.movie_info.release_region
      },
      releaseData() {
        return this.item.movie_info.release_date
      },
      duration() {
        return this.item.movie_info.duration
      },
      tags() {
        return this.item.movie_info.tags
      },
      actors() {
        return this.item.movie_info.actors
      },
      score() {
        return this.item.movie_info.score
      },
      directors() {
        return this.item.movie_info.directors
      },
      coverPage() {
        return this.item.cover_url
      }
    }
  };
</script>
<style lang="scss">
  .page-container-movie {
    background: white;
    min-height: 100vh;

    .item-full-container {
      background: white;


      .video-player-container {
        background: rgba(5, 5, 5, 0.87);
        width: 100%;
        min-height: 210px;
      }

      .video-container {
        width: 100%;
        height: 210px;
        overflow: hidden;
        position: relative;
        background: rgba(5, 5, 5, 0.87);

        .video-info {
          position: absolute;
          z-index: 1;
          width: 100%;
        }

        .video-cover-mask {
          position: absolute;
          width: 100%;
          height: 100%;
          overflow: hidden;
          z-index: 0;

          .play-icon {
            width: 50px;
            height: 50px;
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }

          .img-video-cover {
            display: block;
            width: 100%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 0;
          }

          .auth-tip-container {
            position: absolute;
            background: rgba(0, 0, 0, 0.55);
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-around;

            .desc-container {
              font-size: 16px;
              color: white;
            }
          }

          .duration {
            position: absolute;
            right: 8px;
            bottom: 8px;
            box-sizing: border-box;
            -webkit-box-sizing: border-box;
            height: 18px;
            min-width: 18px;
            color: #fff;
            border-radius: 5px;
            background: rgba(0, 0, 0, 0.7);
            line-height: 12px;
            text-align: center;
            font-size: 10px;
            padding: 3px 3px;
            vertical-align: bottom;
          }

          .try-free {
            position: absolute;
            left: 8px;
            bottom: 8px;
            box-sizing: border-box;
            -webkit-box-sizing: border-box;
            color: rgba(255, 255, 255, 0.93);
            border-radius: 5px;
            background: rgba(0, 0, 0, 0.7);
            text-align: center;
            font-size: 12px;
            padding: 3px 5px;
            vertical-align: bottom;
          }

          .unlock-desc {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            padding: 12px 22px;
            background: rgba(25, 25, 25, 0.8);
            -webkit-border-radius: 15px;
            -moz-border-radius: 15px;
            border-radius: 15px;
            display: flex;
            align-items: center;

            .play-icon-unlock {
              width: 24px;
              height: 24px;
            }

            .unlock-text {
              color: white;
              margin-left: 5px;
            }
          }
        }
      }

      .series-container {
        margin-top: 12px;
      }

      .horizontal-scroll-list-wrap {
        .cell-item {
          display: inline-block;
        }

        .item-list-wrapper {
          padding: 0 10px;
          white-space: nowrap
        }

        .cube-scroll-content {
          display: inline-block
        }
      }

      .series-box {
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
        font-size: 14px;
        width: 56px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        min-width: 42px;
        margin: 0 4px;

        background: #f6f8fa;
        color: grey;
      }

      .selected-series {
        color: #ff6022;
      }

      .detail-info-popup {
        max-height: 50vh;
      }

      .item-display-text-container {
        padding: 12px;
        font-size: 12px;

        .brief-movie {
          padding: 0 8px;
          color: rgba(20, 20, 20, 0.71);
          line-height: 1.5;
          margin-top: 12px;
        }

        .movie-info-container {
          padding: 0 8px;
          line-height: 1.5;
          display: flex;

          .movie-cover {

            .movie-cover-img {
              width: 105px;
              height: auto;
            }
          }

          .movie-info {
            margin-left: 12px;
          }

          ul li {
            color: grey;
            margin-top: 3px;

            span {
              color: rgba(0, 0, 0, 0.83);
            }
          }
        }
      }

      .info-container {
        display: flex;
        height: 50px;
        align-items: center;

        .item-title-container {
          font-size: 18px;
          font-weight: bold;
          padding: 0 10px;
          color: #222;
          flex: 1 1 auto;
        }

        .action-container {
          display: flex;
          height: 100%;
          align-items: center;
          justify-content: flex-end;
          padding: 0 15px;
          color: grey;

          .txt {
            flex: 0 0 auto;
          }
        }
      }

      .movie-preview-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .preview-img {
          position: relative;
          overflow: hidden;
          width: 49%;
          height: 80px;
          margin: 3px 0;

          img {
            width: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            display: block;
            transform: translate(-50%, -50%);
          }
        }
      }

      .action-bar-container {
        padding: 8px 12px;
        display: flex;
        align-items: center;

        .actions {
          flex: 1 1 auto;
          font-size: 18px;
          display: flex;
          align-items: center;

          .action-item {
            display: flex;
            align-items: center;
          }

        }

        .change-line-btn-container {
          display: flex;
          align-items: center;

          .btn-container {
            margin: 0 8px;
          }

          .btn-change-line {
          }
        }
      }
    }

    .back-home {
      padding: 0 13px;
      display: flex;
      align-items: center;
      justify-content: center;

      .txt {
        margin-left: 3px;
      }
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
      opacity: 0;
    }

    .collapse-title {
      color: rgba(0, 0, 0, 0.83);
    }
  }
</style>
